import React, {useEffect} from "react";
import PropTypes from "prop-types";

import {useSearchParams} from "react-router-dom";

import immersify_logo from "../images/immersify_logo.svg";
import shape_1 from "../images/shape_1.svg";
import loader from "../images/loader3.gif";

//import { getMobileOperatingSystem } from '../Utils/getMobileOperatingSystem';

// https://immersifydental.page.link/?link=https://immersifyeducation.com/deeplink?dl[PARAMS_GO_HERE]&apn=com.immersifyeducation.immersifydental&isi=1509735183&ibi=com.immersifyeducation.immersifydental
// https://immersifydental.page.link/?link=https://immersifyeducation.com/deeplink?dl=immersifyeducation://immersifydental?loadScene=DentalID|sceneParams=[ModelGroupLabel:none,ContentGroupLabel:none,mode:quiz]|activityID=3dDental_prac&apn=com.immersifyeducation.immersifydental&isi=1509735183&ibi=com.immersifyeducation.immersifydental

// https://immersifyeducation.com/deeplink?dl=immersifyeducation://immersifydental?loadScene%3DDentalID%7CsceneParams%3D%5BModelGroupLabel:none,ContentGroupLabel:none,mode:quiz%5D%7CactivityID%3D3dDental_prac

// http://localhost:3000/deeplink?dl=%5Bimmersifyeducation%3A%2F%2Fimmersifydental%3Firclickid%3DTEST%5D
// http://localhost:3000/deeplink?dl=%5Bimmersifyeducation%3A%2F%2Fimmersifydental%3Firclickid%3DTESTYT%5D%26apn%3Dcom.immersifyeducation.immersifydental%26isi%3D1509735183%26ibi%3Dcom.immersifyeducation.immersifydental
// http://localhost:3000/deeplink?dl=%5Bimmersifyeducation%3A%2F%2Fimmersifydental%3Firclickid%3DGATESTING2%5D%26apn%3Dcom.immersifyeducation.immersifydental%26isi%3D1509735183%26ibi%3Dcom.immersifyeducation.immersifydental

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

function redirectToDeeplink(deeplink) {
  console.log("Deeplink: ", deeplink)
  window.location.href = deeplink

  //The desktop deeplink schema is immersify:// rather than immersifyeducation://
  // So lets try that
  window.location.href = deeplink.replace("immersifyeducation://", "immersify://")

  // Wait 1.5 seconds before attempting desktop redirect

  setTimeout(async () => {
    if (!(attemptDesktopRedirect(deeplink))) {
      //Desktop redirect failed, redirect to app store or home page
      const mobileOperatingSystem = getMobileOperatingSystem();
      if (mobileOperatingSystem === "iOS") {
        window.location.href = "https://apps.apple.com/gb/app/immersify-learn-interactively/id1509735183";
      } else if (mobileOperatingSystem === "Android") {
        window.location.href = "https://play.google.com/store/apps/details?id=com.immersifyeducation.immersifydental&hl=en_GB";
      } else {
        window.location.href = window.location.origin
      }
    }
  }, 1500)

}

async function attemptDesktopRedirect(path) {
  // Todo: This needs to be replaced with a better solution
  // For now, the goal is to attempt to call the desktop app server
  // and if it fails, redirect to the mobile app

  const userAgent = navigator.userAgent
  const macosStrings = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"]

  const url = "http://localhost:8080/" + path;

  if (macosStrings.some(
    (macosString) => userAgent.includes(macosString)
  )) {

    console.log("Url: ", url)
    console.log("MacOS, attempting redirect")
    window.location.href = url
    console.log("MacOS, href redirect attempted")
    return false; // This is a guess, we don't know if the redirect worked
  }

  console.log("Not MacOS, attempting fetch")

  return await fetch((url)).then(
    (response) => {
      console.log("Not macos, fetch succeeded, response: ", response)
      return response.ok;
    }
  ).catch(
    (error) => {
      console.log("Not macos, fetch failed, error: ", error)
      return false;
    }
  )

}

export const Deeplinks = (props) => {
  const [searchParams] = useSearchParams();
  let deeplink = searchParams.get("dl") || searchParams.get("link");

  if (!deeplink) {
    console.error("No deeplink found, redirecting to origin");
    deeplink = window.location.origin
  }

  // Remove surrounding [] if they exist
  // Regex just removes the first and last character if they are [ or ]
  deeplink = deeplink.replace(/^\[|]$/g, "");

  // Extract the deeplink params
  const dlParams = new URLSearchParams(deeplink.split("?")[1])
  console.log("Dl params: ", dlParams)

  // Redirect to the new deeplink page on the new site
  window.location.href = "https://www.immersify.com/s/open-app?"+dlParams.toString()


  // console.log("Redirecting to deeplink: ", deeplink);

  // // Now a few ways to redirect to the deeplink because some browsers
  // // are picky about how they handle deeplinks/js redirects
  // window.location.href = deeplink;
  // redirectToDeeplink(deeplink);
  // useEffect(() => redirectToDeeplink(deeplink), []);


  return (
    <section className="container-fluid">
      <div className="row">
        <div className="col-xl-7 col-md-6 left_block d-none d-md-block">
          <div className="signup_image">
            <div className="shape_block">
              <div className="shape_1">
                <img alt="placeholder" src={shape_1}/>
              </div>
              <div className="shape_2">
                <img alt="placeholder" src={shape_1}/>
              </div>
            </div>
            <div className="login_text_block">
              <h1>LEARN.</h1>
              <h1>EXPERIENCE.</h1>
              <h1>CONNECT.</h1>
            </div>
          </div>
        </div>
        <div className="col-xl-5 col-md-6">
          <div className="logo_wrap">
            <img alt="placeholder" src={immersify_logo}/>
          </div>
          <div className="signup_form_area redirect_sec">
            <div className="loader_dir">
              <img src={loader} alt="loader"/>
            </div>
            <h2>Redirecting...</h2>
            <h3>Please do not refresh </h3>
            <p>
              If you have been waiting longer than a few seconds
              please
              <a href={deeplink}>
                <button
                >
                  Click here
                </button>
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

Deeplinks.propTypes = {
  deeplinksId: PropTypes.string,
  search: PropTypes.string,
  fullSearch: PropTypes.string
};
